import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import apiClient from "../../services/apiService";
import { useAuth } from "../../context/AuthContext";

const LogOut = () => {
    let  navigate = useNavigate()
    const { logout } = useAuth();

    useEffect(() => {
        async function logoutSync () {
            await apiClient.post("/auth/logout");
            logout();
            navigate('/');
        }

        logoutSync();
    // eslint-disable-next-line
    }, [logout, navigate])

    return (
        <></>
    )
}

export default LogOut